import React, { useState } from "react"
import { Button } from "@gamigo/gatsby-theme-strapi/src/ui"
import { ButtonType } from "@gamigo/gatsby-theme-strapi/src/ui/button/button-elements"
import { IButton } from "@gamigo/gatsby-theme-strapi/gatsby-graphql"
import Modal from "../../modal"
import RegistrationForm from "../../registration-form"

export function shouldShowRegistrationButton(url: string | undefined | null) {
  return url?.trim() === "glyph://game/4111/region/join"
}

export function RegistrationButton({button}:{button: IButton}) {
  const [opened, open] = useState(false);
  return <>
    <Button
      type={button?.type as ButtonType}
      textTransform="uppercase"
      onClick={() => {
        open(true);
      }}
    >{button.link?.label}</Button>
    {<Modal onClose={() => open(false)} opened={opened}>
      <RegistrationForm/>
    </Modal>}
  </>
}
